/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnInit,
	Optional,
	Self,
} from '@angular/core';
import { NgControl, UntypedFormControl } from '@angular/forms';
import { MultiWrapperComponent } from 'src/app/modules/ticket-edit/components/multi-wrapper/multi-wrapper.component';
import { TicketEditBaseComponent } from 'src/app/modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import * as appStrings from '@touchplan/strings';
import { of, takeUntil } from 'rxjs';
import { MilestoneType } from '@touchplan/common';

@Component({
	selector: 'ticket-milestone-type',
	templateUrl: './ticket-milestone-type.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MilestoneTypeComponent extends TicketEditBaseComponent implements OnInit {
	public appStrings = appStrings;
	public milestoneTypes$ = of(
		new Map([
			[MilestoneType.FINISH, { label: 'Finish', value: MilestoneType.FINISH }],
			[MilestoneType.START, { label: 'Start', value: MilestoneType.START }],
		])
	);

	internalField = new UntypedFormControl(null);

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();
		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
		});
	}

	// Overriding this method to coerce undefined values to 'null', that way the dropdown
	// label will read "<not set>", and won't mark the control (and therefore the form)
	// as "dirty".
	writeValue(obj: any) {
		this.internalField.setValue(obj === undefined ? null : obj, { emitEvent: false });
	}
}
